import { useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";

export const useEmailUpdateVerification = () => {
  const { userType } = useContext(AuthContext);
  const navigate = useNavigate();

  const verifyEmailUpdate = async ({ oldEmail, newEmail, OTP, OTP1, password }) => {
    let endpoint = "";
    if (userType === "Charterer") {
      endpoint = `${process.env.REACT_APP_SERVER_URL}/auth/emailUpdateVerification/charterer`;
    } else if (userType === "Vessel Owner") {
      endpoint = `${process.env.REACT_APP_SERVER_URL}/auth/emailUpdateVerification/vesselOwner`;
    } else {
      throw new Error("Invalid user type.");
    }

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ oldEmail, newEmail, OTP, OTP1, password }),
      });

      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.message || "Failed to verify email update.");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw new Error(error.message);
    }
  };

  return useMutation(verifyEmailUpdate, {
    onSuccess: () => {
      navigate("/");
    },
  });
};
